import React, { PropsWithChildren } from "react";

export type DateFormatType = {
    momentDate: string;
    momentDateTime: string;
    momentDateTimeWoSeconds: string;
    momentTime: string;
    momentTimeWoSeconds: string;
    momentMonth: string;
    momentNumberMonth: string;
    placeholderDate: string;
    placeholderYearMonth: string;
    maskDate: string;
    maskDateTime: string;
    maskTime: string;
    maskYearMonth: string;
    separator: string;
};

export function getDefaultDateFormat(): DateFormatType {
    return {
        momentDate: "DD.MM.YYYY",
        momentDateTime: "DD.MM.YY HH:mm:ss",
        momentDateTimeWoSeconds: "DD.MM.YY HH:mm",
        momentTime: "HH:mm:ss",
        momentTimeWoSeconds: "HH:mm",
        momentMonth: "MMMM YYYY",
        momentNumberMonth: "MM.YYYY",
        placeholderDate: "GG.MM.AAAA",
        placeholderYearMonth: "MM.AAAA",
        maskDate: "99.99.9999",
        maskDateTime: "99.99.99 99.99",
        maskTime: "99.99",
        maskYearMonth: "99.9999",
        separator: "alle",
    };
}

export const DateFormatContext = React.createContext<DateFormatType>(getDefaultDateFormat());

export const useDateFormatContext = () => React.useContext(DateFormatContext);

type PropsType = {
    format: DateFormatType;
};

export const DateFormatContextProvider = (props: PropsWithChildren<PropsType>) => {
    return (
        <DateFormatContext.Provider value={props.format}>
            {props.children}
        </DateFormatContext.Provider>
    );
};
